<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <concessionaria-form
            v-show="isModalVisible"
            @close="closeModal"
            :afterCreateAction="loadList"
            :action="concessionariaAction"
            :concessionaria="concessionaria"
          ></concessionaria-form>
        </div>
        <div class="col-md-4"></div>
      </div>
    </div>
    <template>
      <div class="content">
        <div class="container-fluid">
          <div class="row">
            <div class="col-12">
              <card
                class="strpied-tabled-with-hover"
                body-classes="table-full-width table-responsive"
              >
                <template slot="header">
                  <div class="float-left">
                    <h4 class="card-title">Concessionárias Cadastradas</h4>
                  </div>
                  <div class="float-right">
                    <button
                      type="submit"
                      class="btn btn-success btn-fill"
                      @click="novaConcessionaria"
                    >
                      Cadastrar nova Concessionária
                    </button>
                  </div>
                </template>
                <l-table
                  class="table-hover table-striped"
                  :columns="tabelaConcessionarias.columns"
                  :data="tabelaConcessionarias.data"
                >
                  <template slot-scope="{ row }">
                    <td>
                      <b>{{ row.nome }}</b>
                    </td>
                    <td>
                      <button
                        class="btn btn-icon btn-info"
                        style="margin-right: 10px"
                        @click="editarConcessionaria(row)"
                      >
                        <i class="fa fa-pencil"></i>
                      </button>
                      <button
                        class="btn btn-icon btn-danger"
                        @click="handleDelete(row)"
                      >
                        <i class="fa fa-trash-o"></i>
                      </button>
                    </td>
                  </template>
                </l-table>
                <template slot="footer">
                  <v-pagination
                    v-if="tabelaConcessionarias.data.length > 0"
                    v-model="currentPage"
                    :page-count="totalPages"
                    :classes="bootstrapPaginationClasses"
                    :labels="paginationAnchorTexts"
                  ></v-pagination>
                </template>
              </card>
            </div>
          </div>
        </div>
      </div>
    </template>

    <!-- DELETE MODAL -->
    <div v-show="isDeleteModalVisible" @close="closeDeleteModal">
      <transition name="modal-fade">
        <div class="modal-backdrop">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">
                  <strong>Deseja realmente excluir a concessionária?</strong>
                </h5>
              </div>
              <div class="modal-body">
                Esta ação é definitiva e não poderá ser desfeita.
              </div>
              <div class="modal-footer">
                <button
                  type="button"
                  class="btn btn-secondary"
                  data-dismiss="modal"
                  @click.prevent
                  @click="closeDeleteModal()"
                >
                  Fechar
                </button>
                <button
                  type="button"
                  class="btn btn-danger"
                  @click.prevent
                  @click="deleteConcessionaria()"
                >
                  Deletar
                </button>
              </div>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import _ from 'lodash';
import ConcessionariaForm from './Forms/ConcessionariaForm.vue';
import LTable from 'src/components/Table.vue';
import ConcessionariasService from 'src/services/concessionarias';
import vPagination from 'vue-plain-pagination';

const VUE_APP_SPINNER_COLOR = process.env.VUE_APP_SPINNER_COLOR;

const tableColumns = ['Nome', 'Ações'];
export default {
  components: {
    ConcessionariaForm,
    LTable,
    vPagination
  },
  data() {
    return {
      tabelaConcessionarias: {
        columns: [...tableColumns],
        data: []
      },
      isModalVisible: false,
      concessionariaAction: '',
      concessionaria: {},
      isDeleteModalVisible: false,
      concessionariaToDelete: {},
      currentPage: 1,
      totalPages: 1,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      },
      paginationAnchorTexts: {
        first: 'Primeira',
        prev: '<',
        next: '>',
        last: 'Última'
      }
    };
  },
  created() {
    this.loadList();
  },
  methods: {
    loadList() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      ConcessionariasService.listar({ page: this.currentPage })
        .then(response => {
          this.tabelaConcessionarias.data = _.get(response, 'data.result');
          this.totalItens = _.get(response, 'data.count');
          this.totalPages = Math.ceil(this.totalItens / 10);
          loader.hide();
        })
        .catch(error => {
          loader.hide();

          const message =
            _.get(error, 'response.status') === 400 &&
            _.has(error, 'response.data.message')
              ? _.get(error, 'response.data.message')
              : 'Ocorreu algum erro interno. Tente novamente mais tarde.';

          this.$notifications.notify({
            message,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger',
            icon: 'fa fa-exclamation-triangle'
          });
        });
    },
    novaConcessionaria() {
      this.concessionariaAction = 'NEW';
      this.concessionaria = { nome: '' };
      this.isModalVisible = true;
    },
    editarConcessionaria(concessionaria) {
      this.concessionariaAction = 'EDIT';
      this.concessionaria = { ...concessionaria };
      this.isModalVisible = true;
    },
    closeModal() {
      this.isModalVisible = false;
    },
    handleDelete(row) {
      this.isDeleteModalVisible = true;
      this.concessionariaToDelete = row;
    },
    closeDeleteModal() {
      this.isDeleteModalVisible = false;
      this.concessionariaToDelete = {};
    },
    notifyVue(verticalAlign, horizontalAlign, type, message, icon) {
      this.$notifications.notify({
        message: `<span>${message}.</span>`,
        icon: icon,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type
      });
    },
    deleteConcessionaria() {
      const loader = this.$loading.show({
        color: VUE_APP_SPINNER_COLOR
      });

      const successCallback = () => {
        this.notifyVue(
          'top',
          'center',
          'success',
          'Deletado com sucesso.',
          'fa fa-check'
        );
        this.loadList();
        this.closeDeleteModal();
        loader.hide();
      };

      const errorCallback = err => {
        const message =
          _.get(err, 'response.status') === 400 &&
          _.has(err, 'response.data.message')
            ? _.get(err, 'response.data.message')
            : 'Ocorreu algum erro interno. Tente novamente mais tarde.';
        this.notifyVue(
          'top',
          'center',
          'danger',
          message,
          'fa fa-exclamation-triangle'
        );
        this.closeDeleteModal();
        loader.hide();
      };

      ConcessionariasService.deletar({ _id: this.concessionariaToDelete._id })
        .then(successCallback)
        .catch(errorCallback);
    }
  },
  watch: {
    currentPage: function(newValue, oldValue) {
      if (this.currentPage !== oldValue) {
        this.loadList();
      }
    }
  }
};
</script>
<style scoped>
.pagination {
  justify-content: center;
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
}
</style>
